import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { emitter } from '../../util/emitter';
import { renderModel } from '../../util/renderModel';
import { appRoutes } from '../appRoutes';

const isLandingPage = renderModel.isLandingPage();

export const useWidgetUrlEvents = (): void => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isLandingPage) {
      return;
    }

    const handleUpdateArticleUri = (articleUri: string) => {
      const pathname = appRoutes.articleByUri({ articleUri });
      if (pathname !== location.pathname) {
        navigate(pathname);
      }
    };

    const handleUpdateCategoryUri = (categoryUri: string) => {
      const pathname = appRoutes.categoryByUri({ categoryUri });
      if (pathname !== location.pathname) {
        navigate(pathname);
      }
    };

    const handleOpenChatbotPage = () => {
      if (location.pathname !== appRoutes.chatbot()) {
        navigate(appRoutes.chatbot());
      }
    };

    const handleOpenHomePage = () => {
      if (location.pathname !== appRoutes.home()) {
        navigate(appRoutes.home());
      }
    };

    const handleOpenSearchPage = (query: string) => {
      if (location.pathname !== appRoutes.search() || searchParams.get('query') !== query) {
        searchParams.set('query', query);

        navigate({
          pathname: appRoutes.search(),
          search: searchParams.toString(),
        });
      }
    };

    emitter.on('updateArticleUri', handleUpdateArticleUri);
    emitter.on('updateCategoryUri', handleUpdateCategoryUri);
    emitter.on('openChatbotPage', handleOpenChatbotPage);
    emitter.on('openHomePage', handleOpenHomePage);
    emitter.on('openSearchPage', handleOpenSearchPage);

    return () => {
      emitter.remove('updateArticleUri');
      emitter.remove('updateCategoryUri');
      emitter.remove('openChatbotPage');
      emitter.remove('openHomePage');
      emitter.remove('openSearchPage');
    };
  }, [location.pathname]);
};
